import type { Session } from "@/lib/types";

import { SidebarSessionItem } from "./SidebarSessionItem";

interface SidebarSessionListProps {
  sessions: Session[];
  isLoading?: boolean;
}

export function SidebarSessionList({ sessions, isLoading }: SidebarSessionListProps): JSX.Element {
  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-cyber-muted">
        <span className="animate-spin-glow mr-2 inline-block">◐</span>
        Loading...
      </div>
    );
  }

  if (sessions.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center px-4 text-center text-sm text-cyber-muted">
        No sessions yet
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      {sessions.map((session) => (
        <SidebarSessionItem key={session.threadKey} session={session} />
      ))}
    </div>
  );
}
